import { Slot } from 'expo-router'
import { AppSessionProvider } from '@/src/contexts/AppSessionContext'
import { VoiceAssessmentAnalysisReadyToastHost } from '@/src/features/statistics/components/VoiceAssessmentAnalysisReadyToastHost'

export default function ProtectedLayout() {
  return (
    <AppSessionProvider>
      <VoiceAssessmentAnalysisReadyToastHost />
      <Slot />
    </AppSessionProvider>
  )
}
